var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.movie)?_c('div',[_c('video',{staticClass:"video",attrs:{"src":_vm.movie.src,"poster":_vm.movie.preview,"controls":"","preload":"metadata"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }